/** Matches production course cards on /dashboard/me/courses */
export const COURSE_CARD_IMAGE_HEIGHT = 270;

export const getCourseAvatarObjectPosition = (
  positionX?: number | null,
  positionY?: number | null,
): string => {
  const x = positionX ?? 50;
  const y = positionY ?? 100;
  return `${x}% ${y}%`;
};

export const courseCardMediaSx = (
  positionX?: number | null,
  positionY?: number | null,
) => ({
  height: COURSE_CARD_IMAGE_HEIGHT,
  flexShrink: 0,
  backgroundSize: 'cover',
  backgroundPosition: getCourseAvatarObjectPosition(positionX, positionY),
  backgroundColor: '#e2e8f0',
});
